import { useI18N } from "@sundae/react-hooks";
import { NumberI18N, toolkitCx } from "@sundae/ui-toolkit";
import { useWalletDetails } from "@sundae/wallet-react";
import cx from "classnames";
import { FC, memo, useMemo } from "react";

import { useYieldFarmingPositions } from "../../../hooks/farms/useYieldFarmingPositions";
import { getAssetName } from "../../../utils/assets.utils";
import { getPoolName } from "../../../utils/pool.utils";
import AssetWithAssetName from "../../AssetWithAssetName";

const PositionList: FC = () => {
  const { currentLocale } = useI18N();
  const {
    details: { mainAddress, stakingAddress },
  } = useWalletDetails();
  const { mergedPosition } = useYieldFarmingPositions({
    beneficiary: [stakingAddress, mainAddress].sort(),
  });
  const positionValue = useMemo(() => mergedPosition?.value, [mergedPosition?.value]);

  return (
    <>
      {/* -------------------------------------------------------------------------------------------------
       * Locked Position Items
       * -----------------------------------------------------------------------------------------------*/}
      <div className="grid gap-2">
        {positionValue?.map((positionValue, index) => (
          <div
            key={`${positionValue.assetID}-${index}`}
            className={cx(
              "w-full rounded-lg",
              "focus-within:!border-primary dark:focus-within:!border-primary",
              toolkitCx.layout.transition.colors,
              toolkitCx.layout.border.default,
              toolkitCx.layout.border.flashOnFocus,
              toolkitCx.layout.border.weight.default,
              toolkitCx.layout.spacing.both.md
            )}
          >
            <div className="flex w-full items-center justify-between">
              <AssetWithAssetName
                assets={
                  positionValue.pool
                    ? [positionValue.pool.assetA, positionValue.pool.assetB]
                    : positionValue.asset.metadata
                }
                assetName={
                  positionValue.pool ? (
                    <>
                      {getPoolName({
                        assetA: positionValue.pool.assetA,
                        assetB: positionValue.pool.assetB,
                      })}{" "}
                      LP
                    </>
                  ) : (
                    getAssetName(positionValue.asset.metadata)
                  )
                }
              />

              <div className="flex flex-1 items-center justify-end gap-2">
                <NumberI18N
                  locale={currentLocale}
                  size="sm"
                  value={positionValue.assetAmount.value.toNumber()}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default memo(PositionList);
